import { render, staticRenderFns } from "./security.vue?vue&type=template&id=d35acc50&"
import script from "./security.vue?vue&type=script&lang=js&"
export * from "./security.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d35acc50')) {
      api.createRecord('d35acc50', component.options)
    } else {
      api.reload('d35acc50', component.options)
    }
    module.hot.accept("./security.vue?vue&type=template&id=d35acc50&", function () {
      api.rerender('d35acc50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/security.vue"
export default component.exports